module.exports = __webpack_public_path__ + "static/websiteScreenshot-4086e8049c22200f8b544eb3910cd137.png";